import { render, staticRenderFns } from "./selectimg.vue?vue&type=template&id=578f54b9&scoped=true&"
import script from "./selectimg.vue?vue&type=script&lang=js&"
export * from "./selectimg.vue?vue&type=script&lang=js&"
import style0 from "./selectimg.vue?vue&type=style&index=0&id=578f54b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578f54b9",
  null
  
)

export default component.exports